// @flow
import * as React from 'react';
import { reduxForm, formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import styled from 'styled-components';

import moment from "moment/moment";
import get from 'lodash/get';
import _ from 'lodash';
import Settings from '../../../components/Icons/Settings';
import People from '../../../components/Icons/People';
import Ball from '../../../components/Icons/Ball';
import Trade from '../../../components/Icons/Trade';
import ArrowDown from '../../../components/Icons/ArrowDown';
import ArrowUp from '../../../components/Icons/ArrowUp';

import { ButtonPrimary, ButtonAlert } from '../../../components/index';
import { leagueValidate } from "../../../utils/FormValidations/index";
import { BorderedIcon, FormUploadImage } from "../../../components";
import colors from '../../../assets/css/colors';
import * as selectors from "../../../modules/selectors";
import { below } from "../../../assets/css/media";
import { getLeagueFinalsRounds } from '../../../helpers/index';
import getLeagueStartRounds from '../../../modules/selectors/getLeagueStartRounds';
import { LeagueSettings } from './forms/LeagueSettings';
import { AdvancedLeagueSettings } from './forms/AdvancedLeagueSettings';
import { GameplaySettings } from './forms/GameplaySettings';
import { DraftSettings } from './forms/DraftSettings';
import { TradersSettings } from './forms/TradersSettings';

const CreateForm = styled.form`
	box-shadow: 0px 0px 6px 3px #e4e4e4;
	margin: 1em 0;

	button {
		display: block;
		width: 290px;
		margin: 0 auto;
	}

	svg {
		width: 1.1em;
	}
`;

export const RemoveLeagueSection = styled(CreateForm.withComponent('div'))`
	padding: 30px 0;
	text-align: center;
	color: ${colors.darkGrey};

	h4 {
		font-size: 15px;
		font-weight: bold;
		line-height: 1.46;
		margin-bottom: 0.5em;
	}

	p {
		margin-bottom: 20px;
	}
`;

const FormItem = styled.div`
	margin: 0 8em;

	label {
		margin: 0 0 0.2em;
	}

	${below.desktop`
		margin: 0 1em;
	`}
`;

const SubTitle = styled.h4`
	display: flex;
	align-items: center;
	color: ${colors.darkGrey};
	font-weight: bold;
	margin: 1em 0 2em 0;

	div {
		margin-right: .5em;
	}
`;

const UploadAvatarWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background-color: #FFFFFF;
	height: 180px;
	margin-bottom: 35px;
	box-shadow: 0 1px 0 0 rgba(0,0,0,0.25);
	color: ${colors.nrlDarkGreen};

	picture {
		display: flex;
	    width: 100px;
	    height: 100px;
	}
`;

const LeagueName = styled.h3`
	color: ${colors.nrlDarkGreen};
	margin-top: 1em;
	font-size: 20px;
	line-height: 1.3;
	font-weight: bold;
	opacity: ${({ disabled }) => disabled ? '.15' : '1'};
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const AdvancedSettingsWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 2em;

	.sub-title {
		margin-bottom: .5em;
	}
`;

const ButtonWrapper = styled.div`
	display: flex;
	margin: 0 8em;
	padding: 1em 0;
	box-shadow: 0 -1px 0 0 #C0C0C0;

	${below.desktop`
		margin: 0 1em;
	`}

	button {
		text-transform: uppercase;

		${below.desktop`
			width: 170px;
		`}
	}
`;

const checkIsRemove = props => {
	if(props.league.status === 'scheduled' && props.league.draft_status === 'scheduled') {
		return (
			<RemoveLeagueSection>
				<h4>
					Would you like to remove this league?
				</h4>
				<p>
					This action is permanent
				</p>
				<ButtonAlert onClick={props.removeLeague}>
					REMOVE LEAGUE
				</ButtonAlert>
			</RemoveLeagueSection>
		);
	}
	else {
		return null;
	}
};

const get_league_avatar = ({ league_id, avatar_version }) => {
	return process.env.REACT_APP_LEAGUE_AVATARS_PATH+league_id+'.png?v='+avatar_version;
};
type Props = {
	handleSubmit: Function;
	onChangeFile: Function;
	league_name: string;
	league: Object;
	is_show_advanced_settings: boolean;
	toggleForm: Function;
	removeLeague: Function;
	previewImg?: string;
	submitting: boolean;
	is_draft_commissioner: boolean;
	rounds: Object;
	minDate: string;
	maxDate: string;
	is_final_start_round: boolean;
	finals_format: number;
	final_rounds: Array<{ value: number, text: string }>;
	league_size: number;
}
class LeagueSettingsClass extends React.Component<Props> {
	render() {
		const props = this.props;
		return (
			<React.Fragment>
				<CreateForm onSubmit={props.handleSubmit}>
					<UploadAvatarWrapper>
						<FormUploadImage
							name='league_avatar'
							size="100px"
							onChange={props.onChangeFile}
							preview_img={
								props.previewImg ?
									props.previewImg :
									props.league.avatar_version ?
										get_league_avatar({
											league_id: props.league.id,
											avatar_version: props.league.avatar_version,
										}) : ''
							}
						/>
						{!props.league_name ? (
							<LeagueName>props.league.name</LeagueName>
						) : (
							<LeagueName>{props.league_name}</LeagueName>
						)}
					</UploadAvatarWrapper>

					<FormItem>
						<LeagueSettings {...props} />

						<AdvancedSettingsWrapper>
							<div>
								<SubTitle
									className='sub-title'
									is_inactive={props.is_show_advanced_settings}
								>
									<BorderedIcon background='#C0C0C0' hide_border={true}>
										<Settings color='#ffffff' size="2" />
									</BorderedIcon>
									Advanced Settings
								</SubTitle>
							</div>
							<BorderedIcon background='#ffffff' hide_border={true} size="2.5">
								{!props.is_show_advanced_settings ?
									(
										<ArrowDown
											color={colors.darkGrey}
											size="2"
											cursor='pointer'
											onClick={() => {
												props.toggleForm(true);
											}}
										/>
									) : (
										<ArrowUp
											color={colors.darkGrey}
											size="2"
											cursor='pointer'
											onClick={() => {
												props.toggleForm(false);
											}}
										/>
									)
								}
							</BorderedIcon>
						</AdvancedSettingsWrapper>

					</FormItem>

					{props.is_show_advanced_settings &&
					<FormItem>

						<AdvancedLeagueSettings {...props} />

						<SubTitle>
							<BorderedIcon background='#C0C0C0' hide_border={true}>
								<People color='#ffffff' size="2" />
							</BorderedIcon>
							Draft Options
						</SubTitle>

						<DraftSettings {...props} />

						<SubTitle>
							<BorderedIcon background='#C0C0C0' hide_border={true}>
								<Ball color='#ffffff' size="2" />
							</BorderedIcon>
							Game Play
						</SubTitle>
						<GameplaySettings {...props} />
						<SubTitle>
							<BorderedIcon background='#C0C0C0' hide_border={true}>
								<Trade color='#ffffff' size="2" />
							</BorderedIcon>
							Trades & Restricted Free Agents
						</SubTitle>

						<TradersSettings {...props} />

					</FormItem>
					}
					<ButtonWrapper>
						<ButtonPrimary disabled={props.submitting}>
							Update Settings
						</ButtonPrimary>
					</ButtonWrapper>
				</CreateForm>
				{checkIsRemove(props)}
			</React.Fragment>
		);
	}
}

let LeagueSettingsForm = reduxForm({
	form: 'league_manager',
	validate: leagueValidate,
})(LeagueSettingsClass);

const selector = formValueSelector('league_manager');

const mapStateToProps = (state, ownProps) => {
	const league = selectors.leagueDraft.getLeague(state, ownProps);

	const is_finals = selector(state, 'finals') === 1;
	const is_flexible = selector(state, 'play_times') === 'flexible';
	const finals_format = selector(state, 'finals_format');
	const finals_start_round = selector(state, 'finals_start_round');
	const field_name = get(state, 'form.league_manager.active', '');
	const start_round = selector(state, 'start_round');

	const rounds_array = getLeagueStartRounds(state, ownProps).rounds;

	const { final_rounds, finals_start_round_selected } = getLeagueFinalsRounds({
		finals_format, finals_start_round: parseInt(finals_start_round, 10), field_name,
		selected_round_id: parseInt(start_round, 10),
		rounds: _.get(rounds_array, '[0].id') ? _.map(rounds_array, ({ id }: { id: number }) => ({
			value: id,
			text: `ROUND ${id}`,
		})) : []
	});

	return {
		is_finals,
		is_final_start_round: is_flexible && is_finals,
		final_rounds,
		finals_start_round_selected,
		is_traders: selector(state, 'trade_waivers') === 1,
		league_size: selector(state, 'size'),
		is_draft_commissioner: selector(state, 'draft_type') === 'commissioner',
		league_name: selector(state, 'name'),
		maxDate: ownProps.selected_round.start,
		initialValues: {
			id: league.id,
			name: league.name,
			start_round: league.start_round,
			privacy: league.privacy,
			play_times: league.play_times,
			finals: league.finals,
			captains: league.captains,
			emergency: league.emergency,
			lockout: league.lockout,
			trade_waivers: league.trade_waivers,
			waiver_period: league.waiver_period,
			waiver_order: league.waiver_order,
			coaches_box: league.coaches_box,
			bye_rounds: league.bye_rounds,
			rfa_privacy: league.rfa_privacy,
			approve_trade: league.approve_trade,
			size: league.size,
			draft_type: league.draft_type,
			finals_format: league.finals_format,
			finals_start_round: league.finals_start_round,
			draft_start: moment(league.draft_start),
			squad_size: league.squad_size,
			draft_order: league.draft_order,
			draft_turn: league.draft_turn,
		},
		enableReinitialize: true,
	};
};
const mapDispatchToProps = dispatch => {
	return {
		changeFieldValue: function(field, value) {
			dispatch(change('league_manager', field, value));
		},
	};
};
LeagueSettingsForm = connect(
	mapStateToProps,
	mapDispatchToProps
)(LeagueSettingsForm);

export default withRouter(LeagueSettingsForm);


// WEBPACK FOOTER //
// ./src/pages/league/leagueSettings/LeaguesSettingsForm.js